import { render } from "./photoswipe-lightbox.vue?vue&type=template&id=c96404d8"
import script from "./photoswipe-lightbox.vue?vue&type=script&lang=js"
export * from "./photoswipe-lightbox.vue?vue&type=script&lang=js"

import "./photoswipe-lightbox.vue?vue&type=style&index=0&id=c96404d8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__